import React from "react";
import { PortfolioData } from "../types/portfolio";

interface EducationProps {
  data: PortfolioData;
}

const Education: React.FC<EducationProps> = ({ data }) => {
  return (
    <section className="py-24 bg-ivory">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="mb-16">
          <h2 className="text-4xl font-manrope font-bold text-navy mb-4">
            Education
          </h2>
          <div className="h-1 w-16 bg-teal rounded-full"></div>
        </div>
        {/* Education Timeline */}
        {/* Education Timeline */}
        <div className="relative">
          {/* Continuous vertical stepper line */}
          {data.education.length > 1 && (
            <div className="absolute left-[11px] top-3 bottom-3 w-1 bg-teal rounded-full" />
          )}

          <div className="space-y-8">
            {data.education.map((edu, idx) => (
              <div
                key={edu.id}
                className="group relative pl-10 animate-fadeInUp"
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                {/* Timeline Dot */}
                <div className="absolute left-0 top-2 z-10 w-6 h-6 bg-teal rounded-full border-4 border-ivory group-hover:bg-gold transition-colors duration-300" />

                {/* Card */}
                <div className="bg-white p-8 rounded-xl border-2 border-gray-100 hover:border-teal transition-all duration-300 hover:shadow-lg">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-4">
                    <div>
                      <h3 className="text-2xl font-manrope font-bold text-navy mb-2 group-hover:text-teal transition-colors">
                        {edu.degree}
                      </h3>

                      <p className="text-lg text-slate font-semibold mb-1">
                        {edu.institution}
                      </p>
                    </div>

                    <span className="self-start text-sm font-semibold text-white bg-teal px-4 py-2 rounded-full group-hover:bg-gold transition-colors">
                      {edu.status}
                    </span>
                  </div>

                  {/* Details */}
                  <div className="flex flex-col sm:flex-row gap-6 text-slate">
                    <div>
                      <p className="text-xs font-semibold text-teal uppercase tracking-widest mb-1">
                        Period
                      </p>
                      <p className="font-semibold">{edu.period}</p>
                    </div>

                    <div>
                      <p className="text-xs font-semibold text-teal uppercase tracking-widest mb-1">
                        CGPA
                      </p>
                      <p className="font-semibold">{edu.cgpa}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Supporting Note */}
        <div className="mt-16 p-8 bg-white rounded-xl border border-gray-200 text-center">
          <p className="text-slate text-base leading-relaxed">
            Education combined with professional experience at Kyndryl provides
            a well-rounded foundation in technical infrastructure, business
            analysis, and strategic management principles.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Education;
